import React, { Component } from 'react';
import {connect} from 'react-redux';
import PodcastOverviewComponent from "../../../../../common/podcasts/PodcastOverviewComponent"
import PodcastHeroComponent from "../../../../../common/podcasts/PodcastHeroComponent";
import * as todoListActions from '../../../../../../actions/todo_list/todo_list';
import { PrismicDocumentHelper } from '../../../../../../helpers/prismicHelpers/PrismicHelpers';
import { PodcastsSeriesListHelper, PodcastsListHelper } from '../../../../../../helpers/prismicHelpers/prismic-custom-helpers/HomepageCardHelpers';

class PodcastsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedDetails: null,
            episodes: null,
            episodeList: null,
            series: null,
            defaultSeries: null,
            currentIndex: null,
            backgroundImage: null,
            defaultEpisode: null
        }
    }

    componentWillMount() {
        this.getPodcasts();
    }

  async getPodcasts(){
        const seriesData = await PrismicDocumentHelper('document.id', this.props.params.podcastId, false, 'at')
        const series = PodcastsSeriesListHelper(seriesData);

        this.setState({
            series,
            selectedDetails: series.seriesList[0],
            defaultSeries: series.seriesList[0]
        })
        const arr = []

        series.seriesList.map(podcast => {
            podcast.episodes.map(id => {
                arr.push(id.podcast_episode.id )
            })
        })
        const episodeData = await PrismicDocumentHelper('document.id', arr, false, 'in')
        const episodes = PodcastsListHelper(episodeData)
        this.setState({ episodes,
                        episodeList: episodes.podcastsList,
                        defaultEpisode: episodes.podcastsList[0] })
    }

    handleDescriptionClick = (podcast, index) => {
        this.setState({
                selectedDetails: podcast,
                currentIndex: index,
                backgroundImage: podcast.img
            });
    };

    renderImage() {
        return (
            this.state.backgroundImage && this.state.backgroundImage ?
            <div className="image"
                 style={{backgroundImage: `url(${this.state.backgroundImage})`}}></div>
            :
            <div className="image"
                 style={{backgroundImage: `url(${this.state.selectedDetails.image})`}}></div>
        )
    }

    render() {

        return(
            <main className="podcasts-wrapper" role="main">
                {this.state.selectedDetails && (
                    <article className="podcast-page theme-page-whole-blue darker">
                        {this.renderImage()}
                        <PodcastHeroComponent
                            series={this.state.selectedDetails}
                            defaultSeries={this.state.defaultSeries}
                            episodes={this.state.episodes}
                            currentIndex={this.state.currentIndex}
                            defaultEpisode={this.state.defaultEpisode}
                            todoListUpdate={this.props.updateTodoList}
                        />
                        <div className="container">
                            <div className="row">
                                <div className="col-12 episode-list-wrapper">
                                    <h4 className="heading-two">Episodes</h4>
                                    <ul className="episode-list">
                                        {this.state.episodeList && this.state.episodeList.map((episode, i) => {
                                            return (
                                                <PodcastOverviewComponent
                                                    key={i}
                                                    index={i}
                                                    episode={episode}
                                                    handleDescriptionClick={this.handleDescriptionClick}
                                                />
                                            );
                                        })}
                                    </ul>
                                </div>
                                <div className="col-12 listen-to-wrapper">
                                    <p className="body-copy">
                                        Listen to the podcast on
                                        <a href="https://itunes.apple.com/us/podcast/id1437901566" target="_blank"
                                           className="clickable"> iTunes</a>,
                                        <a href="https://open.spotify.com/show/5b922rPHTIf8gkQEklxzQe?si=ckEX0ND5QMapW8UjkVuBuA"
                                           target="_blank" className="clickable"> Spotify</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </article>
                )}
            </main>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateTodoList: (personId, listItem) => dispatch(todoListActions.updateTodoList(personId, listItem))
  }
};

export default connect(null, mapDispatchToProps)(PodcastsPage);



// WEBPACK FOOTER //
// src/client/components/site/features/training/podcasts/pages/PodcastsPage.js